export type ErrorType = {
    code: string;
    message: string;
    orderId?: string;
    blocking: boolean;
    extra?: { [key: string]: unknown };
};

export enum IntegrationsServiceErrorCodesEnum {
    WAREHOUSE_PICKUP_ZONE_MISMATCH = 'WAREHOUSE_PICKUP_ZONE_MISMATCH',
    TOKEN_EXPIRED = 'TOKEN_EXPIRED',
    ADDRESS_NOT_VERIFIED = 'ADDRESS_NOT_VERIFIED',
    UNPAID_ORDER = 'UNPAID_ORDER',
    DELIVERED_ORDER = 'DELIVERED_ORDER',
    UNKNOWN = 'UNKNOWN',
}

export class IntegrationsErrors {
    static errors = {
        [IntegrationsServiceErrorCodesEnum.WAREHOUSE_PICKUP_ZONE_MISMATCH]: {
            code: IntegrationsServiceErrorCodesEnum.WAREHOUSE_PICKUP_ZONE_MISMATCH,
            message: "The warehouse is outside of user's pickup zone",
            blocking: true,
        },
        [IntegrationsServiceErrorCodesEnum.TOKEN_EXPIRED]: {
            code: IntegrationsServiceErrorCodesEnum.TOKEN_EXPIRED,
            message: 'Token expired',
            blocking: true,
        },
        [IntegrationsServiceErrorCodesEnum.ADDRESS_NOT_VERIFIED]: {
            code: IntegrationsServiceErrorCodesEnum.ADDRESS_NOT_VERIFIED,
            message: 'Failed retrieving seller address',
            blocking: true,
        },
        [IntegrationsServiceErrorCodesEnum.UNPAID_ORDER]: {
            code: IntegrationsServiceErrorCodesEnum.UNPAID_ORDER,
            message: 'Unpaid order',
            blocking: false,
        },
        [IntegrationsServiceErrorCodesEnum.DELIVERED_ORDER]: {
            code: IntegrationsServiceErrorCodesEnum.DELIVERED_ORDER,
            message: 'Order delivered yet',
            blocking: false,
        },
        [IntegrationsServiceErrorCodesEnum.UNKNOWN]: {
            code: IntegrationsServiceErrorCodesEnum.UNKNOWN,
            message: 'Unknown',
            blocking: false,
        },
    };

    static getError(data: {
        errorCode: IntegrationsServiceErrorCodesEnum;
        orderId?: string;
        extra?: { [key: string]: unknown };
    }): ErrorType {
        const error = this.errors[data.errorCode];
        if (!error) return { orderId: data.orderId, ...this.errors[IntegrationsServiceErrorCodesEnum.UNKNOWN] };

        return { ...error, orderId: data.orderId, ...error, extra: data.extra };
    }

    static translateErrorMessage(errorCode: IntegrationsServiceErrorCodesEnum): string {
        console.log(
            '🚀 ~ file: integrations-errors.ts:64 ~ IntegrationsErrors ~ translateErrorMessage ~ errorCode:',
            errorCode,
        );
        if (!errorCode) return '-';

        const errors = {
            [IntegrationsServiceErrorCodesEnum.WAREHOUSE_PICKUP_ZONE_MISMATCH]:
                'El almacén está fuera de la zona de recogida del usuario.',
            [IntegrationsServiceErrorCodesEnum.TOKEN_EXPIRED]: 'Token expirado.',
            [IntegrationsServiceErrorCodesEnum.ADDRESS_NOT_VERIFIED]: 'No se pudo recuperar la dirección del vendedor.',
            [IntegrationsServiceErrorCodesEnum.UNPAID_ORDER]: 'Orden impaga.',
            [IntegrationsServiceErrorCodesEnum.DELIVERED_ORDER]: 'Orden ya entregada.',
            [IntegrationsServiceErrorCodesEnum.UNKNOWN]: 'Desconocido.',
        };

        return errors[errorCode] ?? '-';
    }
}
